import { Injectable } from '@angular/core';
import { UniversalService } from '@commoncore/services/universal.service';


@Injectable({
  providedIn: 'root'
})
export class CustomSortService {

  constructor(public universalService:UniversalService) { }

  sortByDates(files,sortedArray,mimeTypeSummaryArray,sorting,appendAtFirst?:boolean) { 
    var year  = "";
    var monthNo = "";
    if(sorting == "createdDate" || sorting == "uploadedDate"){
      year = "cYear"
      monthNo = "cMonthNo"
    }else if(sorting == "modifiedDate"){
      year = "modYear"
      monthNo = "modMonthNo"
    }else if( sorting == "lastAccessedDate"){
      year = "lastAccYear"
      monthNo = "lastAccMonthNo"
    } else if( sorting == "uploaded"){
      year = "uYear"
      monthNo = "uMonthNo"
    }
    var self = this;
    var Months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
    var objects = [];
    var isNewObjAdded = false;
    let uploadedFileMonthName = "";
    /* converting array to hashmap for segregating files into respective months */
    let sortedFilesHashMap = sortedArray.reduce((acc, entry) => {
      acc.set(entry.month,entry);
      return acc;
    }, new Map());
    const mimeTypeSummaryHashMap = mimeTypeSummaryArray.reduce((acc, entry) => {
      acc.set(entry.month,entry);
      return acc;
    },new Map());
    /* converting array to hashmap for segregating files into respective months */
    files.forEach(function(obj){
        objects = [];
        var tempArray = [];
        if ((obj["format"] == "Folder"|| obj["objectType"] == 'BR') && !self.universalService.isUserOnSharedLinkByMe) {
          let selectedObjectKeys = new Set(self.universalService.foldersArray.map(obj => obj.objectKey));
          if(!selectedObjectKeys.has(obj["objectKey"]) && (self.universalService.popUpToBeOpened == 'create Folder' || appendAtFirst)){ // this condition is when the paginations happened and after creating a new folder, it should appear at the 1st position
            tempArray.push(obj);
            self.universalService.foldersArray = tempArray.concat(self.universalService.foldersArray)
          }else if(!selectedObjectKeys.has(obj["objectKey"])){
            self.universalService.foldersArray.push(obj)
          }
        } else {
          let monthKey = obj[year] + "-" + Months[obj[monthNo]];
          let month = sortedFilesHashMap.get(monthKey);
          if (month) {
            if (month.objects) {
              objects = month.objects;
            }
            objects.push(obj);
            uploadedFileMonthName = month["monthName"] + " " + month["Year"];
            objects = Array.from(new Set(objects));
            month.objects = objects;
            sortedFilesHashMap.set(monthKey,month)
          }else {
            let monthKey = obj[year] + "-" + Months[obj[monthNo]];
            let month = mimeTypeSummaryHashMap.get(monthKey);
            if (month) {
              objects.push(obj);
              let newMonthData = {
                "month": month["month"],
                "fileCount": month["fileCount"],
                "Year": obj[year],
                "monthName": self.universalService.LONG_MONTH_NAMES[obj[monthNo]],
                "objects": objects
              }
              uploadedFileMonthName = month["monthName"] + " " + month["Year"];
              let isNewMonthAdded = false;
              /* this snippet is to reposition the month when an object is uploaded and sort is changed, commmit if for the initial change (ea06114d72912d220e72a779fa6e5778e13cb8f4) */
              sortedArray = Array.from(sortedFilesHashMap.values());
              sortedArray.forEach((obj,i)=>{
                let summaryMonth = sortedArray[i].month;
                if(new Date(month["month"]).getTime() > new Date(summaryMonth).getTime()){
                  uploadedFileMonthName = newMonthData["monthName"] + " " + newMonthData["Year"];
                  sortedArray.splice(i,0, newMonthData);
                  sortedFilesHashMap = sortedArray.reduce((acc, entry) => {
                    acc.set(entry.month,entry);
                    return acc;
                  }, new Map())
                  isNewMonthAdded = true;
                  return
                }
              })
              /* this snippet is to reposition the month when an object is uploaded and sort is changed, commmit if for the initial change (ea06114d72912d220e72a779fa6e5778e13cb8f4) */
              if(isNewMonthAdded== false){
                sortedFilesHashMap.set(monthKey,newMonthData)
              }
            }else{ // this is for the filters which dont have summary API, but needs to get the count (example: recent files,favorites)
              objects.push(obj)
              let newMonthData = {
                "month": monthKey,
                "Year": obj[year],
                "monthName": self.universalService.LONG_MONTH_NAMES[obj[monthNo]],
                "objects": objects
              }
              uploadedFileMonthName = newMonthData["monthName"] + " " + newMonthData["Year"];
              sortedFilesHashMap.set(monthKey,newMonthData)
              // isNewObjAdded = true;
            }
          }
        }
      })
    /* converting hashmap to array, as all the updations for objects are happening on array */
      sortedArray = Array.from(sortedFilesHashMap.values());
    /* converting hashmap to array, as all the updations for objects are happening on array */
    var array = [];
    sortedArray.forEach(function (obj) {
        array = array.concat(obj["objects"])
    })
    if(isNewObjAdded && this.universalService.openFolderContent) {
      sortedArray = sortedArray.sort((a, b) => {
        return (b.month.replace("-","") - a.month.replace("-",""))
      });
    }
    return [sortedArray,array,{"month":uploadedFileMonthName}];
  }



  sortByNames(files,sortedbyNameArray,sortingOrder:string = "asc",appendAtFirst?:boolean){
    var self = this;
    var letters = /^[A-Za-z]+$/ 
    var objects=[];
    let uploadedFileLetter = "";
    let sortedLettersHashMap = sortedbyNameArray.reduce((acc, entry) => {
      acc.set(entry.letter,entry);
      return acc;
    }, new Map());
    files.forEach(function(obj){
        objects = [];
        var tempArray = [];
        if((obj["format"] == "Folder"|| obj["objectType"] == 'BR') && !self.universalService.isUserOnSharedLinkByMe){
          let selectedObjectKeys = new Set(self.universalService.foldersArray.map(obj => obj.objectKey));
          if(!selectedObjectKeys.has(obj["objectKey"]) && appendAtFirst){
            tempArray.push(obj);
            self.universalService.foldersArray = tempArray.concat(self.universalService.foldersArray)
          }else if(!selectedObjectKeys.has(obj["objectKey"])){
            self.universalService.foldersArray.push(obj);
          }
         }else { 
          var firstChar = obj["objectName"].charAt(0);
          if(!firstChar.match(letters)){
            firstChar = '#'
          }

          let letter = sortedLettersHashMap.get(firstChar.toUpperCase())

          if (letter) {
            if(letter["objects"]){
              objects = letter["objects"];
            }else{
              objects = [];
            }

            objects.push(obj);
            objects = Array.from(new Set(objects));
            uploadedFileLetter = letter;
            letter["letter"] = firstChar.toUpperCase();
            letter["objects"] = objects;
            sortedLettersHashMap.set(letter["letter"],letter);
          } else{
            objects.push(obj);
            uploadedFileLetter = firstChar.toUpperCase();
            let newLetter = {
              "letter":firstChar.toUpperCase(),
              "objects": objects
            } 
            sortedLettersHashMap.set(newLetter["letter"],newLetter);
          }
        }
      })
       /* converting hashmap to array, as all the updations for objects are happening on array */
       sortedbyNameArray = Array.from(sortedLettersHashMap.values());
       /* converting hashmap to array, as all the updations for objects are happening on array */
      sortedbyNameArray.sort(this.dynamicSort("letter",sortingOrder))
      if(!appendAtFirst)
        self.universalService.foldersArray.sort(this.dynamicSort("objectName",sortingOrder))
      var array =[];
      sortedbyNameArray.forEach(function(obj,index){
        array = array.concat(obj["objects"])
      })
      return [sortedbyNameArray,array,{"month":uploadedFileLetter}];
  }

  dynamicSort(key,order) {
    return function (a,b) {
      if(order == "asc"){
        return a[key].localeCompare(b[key]);  
      }else{
        return b[key].localeCompare(a[key]);
      }
         
    }
  }

  sortListViewFilesByAttribute(arr, dir, type) {

    
    var sortedFileList = [];
    var sortedFolderList = [];
   
    arr.forEach(function(obj) {
      if(obj){
        if ((obj.objectType == 'FR' && obj.objectType) || (obj.FullObject && obj.FullObject.objectType == 'FR')) {
          sortedFolderList.push(obj);
        }else if (obj.objectType != 'FR' && obj.objectType != 'BR') {
          sortedFileList.push(obj);
        }
      }
    });

    if (type == 'fileCreatedDate' && dir == 'Descending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.fileCreatedDate < b.FullObject.fileCreatedDate) {
          return 1;
        }
        if (a.FullObject.fileCreatedDate > b.FullObject.fileCreatedDate) {
          return -1;
        }
        return 0;
      });

      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.fileCreatedDate < b.FullObject.fileCreatedDate) {
          return 1;
        }
        if (a.FullObject.fileCreatedDate > b.FullObject.fileCreatedDate) {
          return -1;
        }
        return 0;
      });
    } else if (type == 'lastModifiedDate' && dir == 'Descending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        a = a["FullObject"]?a["FullObject"]:a
        b = b["FullObject"]?b["FullObject"]:b
        if (a.lastModifiedDate < b.lastModifiedDate) {
          return 1;
        }
        if (a.lastModifiedDate > b.lastModifiedDate) {
          return -1;
        }
        return 0;
      });

      sortedFileList = sortedFileList.sort(function(a, b) {
        a = a["FullObject"]?a["FullObject"]:a
        b = b["FullObject"]?b["FullObject"]:b
        if (a.lastModifiedDate < b.lastModifiedDate) {
          return 1;
        }
        if (a.lastModifiedDate > b.lastModifiedDate) {
          return -1;
        }
        return 0;
      });
    } else if (type == 'createdDate' && dir == 'Descending') {
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.createdDate < b.FullObject.createdDate) {
          return 1;
        }
        if (a.FullObject.createdDate > b.FullObject.createdDate) {
          return -1;
        }
        return 0;
      });
    }else if (type == 'favoriteDate' && dir == 'Descending') {
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.favoriteDate < b.favoriteDate) {
          return 1;
        }
        if (a.favoriteDate > b.favoriteDate) {
          return -1;
        }
        return 0;
      });
    }

    if (type == 'fileCreatedDate' && dir == 'Ascending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.fileCreatedDate < b.FullObject.fileCreatedDate) {
          return -1;
        }
        if (a.FullObject.fileCreatedDate > b.FullObject.fileCreatedDate) {
          return 1;
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.fileCreatedDate < b.FullObject.fileCreatedDate) {
          return -1;
        }
        if (a.FullObject.fileCreatedDate > b.FullObject.fileCreatedDate) {
          return 1;
        }
        return 0;
      });
    } else if (type == 'lastModifiedDate' && dir == 'Ascending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.lastModifiedDate < b.FullObject.lastModifiedDate) {
          return -1;
        }
        if (a.FullObject.lastModifiedDate > b.FullObject.lastModifiedDate) {
          return 1;
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.lastModifiedDate < b.FullObject.lastModifiedDate) {
          return -1;
        }
        if (a.FullObject.lastModifiedDate > b.FullObject.lastModifiedDate) {
          return 1;
        }
        return 0;
      });
    } else if (type == 'createdDate' && dir == 'Ascending') {      
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.createdDate < b.FullObject.createdDate) {
          return -1;
        }
        if (a.FullObject.createdDate > b.FullObject.createdDate) {
          return 1;
        }
        return 0;
      });
    }
    if (type == 'objectName' && dir == 'Ascending') {

      sortedFolderList = sortedFolderList.sort(function(a, b) {
        
        if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
          return -1;
        }
        if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
          return -1;
        }
        if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    }
    if (type == 'objectName' && dir == 'Descending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
          return 1;
        }
        if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
          return -1;
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
          return 1;
        }
        if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    }
    if (type == 'mimeType' && dir == 'Ascending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.mimeType < b.FullObject.mimeType) {
          return -1;
        }
        if (a.FullObject.mimeType > b.FullObject.mimeType) {
          return 1;
        }
        if (a.FullObject.mimeType == b.FullObject.mimeType) {
          if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
            return -1;
          }
          if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
            return 1;
          }
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.mimeType < b.FullObject.mimeType) {
          return -1;
        }
        if (a.FullObject.mimeType > b.FullObject.mimeType) {
          return 1;
        }
        if (a.FullObject.mimeType == b.FullObject.mimeType) {
          if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
            return -1;
          }
          if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
            return 1;
          }
        }
        return 0;
      });
    }
    if (type == 'mimeType' && dir == 'Descending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.mimeType < b.FullObject.mimeType) {
          return 1;
        }
        if (a.FullObject.mimeType > b.FullObject.mimeType) {
          return -1;
        }
        if (a.FullObject.mimeType == b.FullObject.mimeType) {
          if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
            return -1;
          }
          if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
            return 1;
          }
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.FullObject.mimeType < b.FullObject.mimeType) {
          return 1;
        }
        if (a.FullObject.mimeType > b.FullObject.mimeType) {
          return -1;
        }
        if (a.FullObject.mimeType == b.FullObject.mimeType) {
          if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
            return -1;
          }
          if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
            return 1;
          }
        }
        return 0;
      });
    }
    if (type == 'sizeInBytes' && dir == 'Ascending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
          return -1;
        }
        if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.sizeInBytes < b.sizeInBytes) {
          return -1;
        }
        if (a.sizeInBytes > b.sizeInBytes) {
          return 1;
        }
        return 0;
      });
    }
    if (type == 'sizeInBytes' && dir == 'Descending') {
      sortedFolderList = sortedFolderList.sort(function(a, b) {
        if (a.FullObject.objectName.toLowerCase() < b.FullObject.objectName.toLowerCase()) {
          return -1;
        }
        if (a.FullObject.objectName.toLowerCase() > b.FullObject.objectName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      sortedFileList = sortedFileList.sort(function(a, b) {
        if (a.sizeInBytes < b.sizeInBytes) {
          return 1;
        }
        if (a.sizeInBytes > b.sizeInBytes) {
          return -1;
        }
        return 0;
      });
      
    }

    var currentFolderContent = [];
    Array.prototype.push.apply(currentFolderContent, sortedFolderList);
    Array.prototype.push.apply(currentFolderContent, sortedFileList);


    return currentFolderContent;
  }



  createSortedObjectFormatsForAccessing(fileList,sortedArray){
    var data = (sortedArray[0]?(sortedArray[0]["objects"]?sortedArray[0]["objects"]:sortedArray):sortedArray)
    var sortedData = [{
      "objects":data.concat(fileList)
    }]
    return [sortedData,data.concat(fileList)]
  }
}
